/*
 * DataTableLoading
 * @module DataTable
 * @flow
 */

import React from 'react';
import styled, { css } from 'styled-components/macro';
import { ifProp } from 'styled-tools';

import { Gag } from '~/components/Gag';
import { Loader } from '~/components/Loader';

export type DataTableLoadingProps = {
  loading?: boolean,
};

const DataTableLoadingGap = styled(Gag)`
  ${ifProp(
    'highlighted',
    css`
      top: 37px;
    `,
  )};
`;

/**
 * DataTableLoading React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {boolean} [props.loading] - loading state
 * @example <caption>Simple usage</caption>
 * <DataTableLoading loading >
 * @returns {React.Node<*>} React-component
 */
export const DataTableLoading = ({ loading, ...rest }: DataTableLoadingProps) =>
  loading ? (
    <DataTableLoadingGap
      testid="datatable-loading"
      icon={<Loader />}
      palette="grayscale"
      {...rest}
    />
  ) : null;
